import {createSlice} from "@reduxjs/toolkit";

const initialSettingconfigState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  settingconfigForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const settingconfigSlice = createSlice({
  name: "settingconfig",
  initialState: initialSettingconfigState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findSettingconfig
    settingconfigFetched: (state, action) => {
      state.actionsLoading = false;
      state.settingconfigForEdit = action.payload.settingconfigForEdit;
      state.error = null;
    },
    // createSettingconfig
    settingconfigCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // updateSettingconfig
    settingconfigUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
  }
});
